import { commonActions } from "../constants"

export const messageText = (data) => {
    return {
        type: commonActions.MESSAGE_TEXT,
        payload: data
    }
}

export const labelValue = (data) => {
    return {
        type: commonActions.LABEL,
        payload: data
    }
}

export const seedingDataList = (data) => {
    return {
        type: commonActions.SEEDING_DATA,
        payload: data
    }
}

export const badgeData = (data) => {
    return {
        type: commonActions.BADGE_DATA,
        payload: data
    }
}

export const ColumnData = (data) => {
    return {
        type: commonActions.COLUMN_DATA,
        payload: data
    }
}

export const ColumnLockToggle = (data) => {
    return {
        type: commonActions.COLUMN_LOCK_TOGGLE,
        payload: data
    }
}

export const SavedColumnData = (data) => {
    return {
        type: commonActions.SAVED_COLUMN_DATA,
        payload: data
    }
}

export const SaveFilterData = (data) => {
    return {
        type: commonActions.SAVED_FILTER_DATA,
        payload: data
    }
}

export const PerPageData = (data) => {
    return {
        type: commonActions.PER_PAGE,
        payload: data
    }
}